import "./BigDividerVolta.scss";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { data } from "../../data/data";

function BigDividerVolta(props) {
  const tl = useRef();
  const arrowsLeft = useRef();
  const arrowsRight = useRef();

  useEffect(() => {
    // tl.current = gsap.timeline({});
    // tl.current.fromTo(
    //   [arrowsLeft.current, arrowsRight.current],
    //   { y: -6, autoAlpha: 0 },
    //   {
    //     y: 6,
    //     autoAlpha: 1,
    //     repeat: -1,
    //     duration: 1,
    //     ease: "sine.out",
    //   }
    // );
  }, []);

  return (
    <div
      id={props.id}
      className={`big-divider-volta ${props.background}Background ${props.color}`}
    >
      <h1 className={`title ${props.color || ""}`}>{props.data.title}</h1>
      <img src={props.data.icon} alt="" className="icon" />
    </div>
  );
}

export default BigDividerVolta;
